
namespace GeniuzPOS.InventoryReport {

    @Serenity.Decorators.registerClass()
    export class IcReport07SkuGrid extends Serenity.EntityGrid<IcReport07SkuRow, any> {
        // static mypassvalue: any;
        protected getColumnsKey() { return IcReport07SkuColumns.columnsKey; }
        protected getDialogType() { return IcReport07SkuDialog; }
        protected getIdProperty() { return IcReport07SkuRow.idProperty; }
        protected getInsertPermission() { return IcReport07SkuRow.insertPermission; }
        protected getLocalTextPrefix() { return IcReport07SkuRow.localTextPrefix; }
        protected getService() { return IcReport07SkuService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
        

        private getFilterDescriptions(grid: Serenity.DataGrid<any, any>, gridColumns: Slick.Column[], options: GeniuzPOS.Common.Helpers.IcReportPdfOptions): any {
            let request = Q.deepClone(grid.view.params) as Serenity.ListRequest;
            let columns = Object.keys(options.columnStyles)
            

            let descriptions: string[] = [];
            
            // var a =IcReport07SkuGrid.mypassvalue
            // let el = document.createElement('span');
            // let shop = QRreport.QRyStockcardRow.getLookup().items[1].SkuCode;
            // console.log(this)
            // console.log(this.element[0].innerText)
            let g = this.element[0].innerText
            var newarr = g.split("\n",28); 
            console.log(newarr)
            // console.log(newarr[17])
            console.log(newarr[21])
            descriptions.push(newarr[23])           


            
            return [descriptions, gridColumns];
        }

        protected getColumns() {
            var columns = super.getColumns();
            
            return columns;
        }

        protected usePager() {
            return false;
        }

        protected createToolbarExtensions() {
            super.createToolbarExtensions();

            // this.slickGrid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());

            var groupingMixin = new Serenity.DraggableGroupingMixin({
                grid: this
            });

            // setting ShipCountry, ShipCity columns as initially grouped for this sample
            // you could add [GroupOrder(1)] to ShipCountry, and [GroupOrder(2)] to ShipCity
            // in OrderColumns.cs instead (recommended way)
            groupingMixin.plugin.setDroppedGroups(["SkuCode"]);
        }
        protected markupReady() {
            super.markupReady();

            // expanding all level 0 (Country) and level 1 (City) groups initially
            this.view.expandAllGroups(0);
            // this.view.expandAllGroups(1);
            // this.view.expandAllGroups(2);

        }

       

        protected getButtons(): Serenity.ToolButton[] {
            var buttons = super.getButtons();
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "column-picker-button"), 1);

            

            buttons.push(Common.Helpers.ExcelExportHelper.createToolButton({
                grid: this,
                service: IcReport07SkuService.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));

            let reportTitle = 'รายงานสต๊อกการ์ด (รายละเอียดการเคลื่อนไหวรวมคลัง)'
            
            // Max page width = 277
            let columnStyles: { [dataKey: string]: GeniuzPOS.Common.Helpers.AutoTableStyles } = {
                0: { field: "SkuCode", title: "รหัสสินค้า", cellWidth: 20,isHidden: true },
                1: { field: "RowRunNo", title: "No.", cellWidth: 7 },
                2: { field: "TranDate", title: "วันที่ปรับปรุง", cellWidth: 30 ,overflow: 'linebreak' , halign: 'center'},
                3: { field: "SysDocNo", title: "เลขที่เอกสาร", cellWidth: 30  ,overflow: 'linebreak'},
                4: { field: "RefDocNo1", title: "อ้างอิง", cellWidth: 30 ,overflow: 'linebreak'},
                5: { field: "DocDate", title: "วันที่เอกสาร", cellWidth: 20, overflow: 'linebreak' , halign: 'center'},
                6: { field: "TranType", title: "Type", cellWidth: 10, halign: 'center' },

                7: { field: "QtyAdd", title: "รับ", cellWidth: 20, halign: 'right' },                
                8: { field: "QtyDel", title: "จ่าย",  cellWidth: 20, halign: 'right'  },
                9: { field: "QtyBalance", title: "Qty.คงเหลือ", cellWidth: 20, halign: 'right' },

                10: { field: "CostAdd", title: "รับ", cellWidth: 20, halign: 'right' },
                11: { field: "CostDel", title: "จ่าย", cellWidth: 20, halign: 'right'  },
                12: { field: "CostBalance", title: "มูลค่าคงเหลือ", cellWidth: 20, halign: 'right' },
                // 9: { field: "SizeId", title: "ขนาด", isHidden: true },
                // 10: { field: "ColorId", title: "สี", isHidden: true },
                // 11: { field: "SupplId", title: "ผู้จำหน่าย", isHidden: true },
                // 12: { field: "SupplName", title: "ผู้จำหน่าย", cellWidth: 65},
                // 13: { field: "CatCode", title: "หมวดสินค้า", isHidden: true },
                // 14: { field: "CatName", title: "หมวดสินค้า", isHidden: true },
                // 15: { field: "SubCat1Code", title: "หมวดสินค้า-2", isHidden: true },
                // 16: { field: "SubCat1Name", title: "หมวดสินค้า-2", isHidden: true },
                // 17: { field: "SubCat2Code", title: "หมวดสินค้า-3", isHidden: true },
                // 18: { field: "SubCat2Name", title: "หมวดสินค้า-3", isHidden: true },
                // 19: { field: "TasteId", title: "กลิ่น/รส", isHidden: true },
                // 20: { field: "MatTypeId", title: "วัสดุที่ใช้", isHidden: true },
                // 21: { field: "ConsignFg", title: "สินค้าฝากขาย?", isHidden: true },
                // 22: { field: "PurLeadTime", title: "ระยะเวลาสินค้าเข้า", cellWidth: 20, halign: 'right' },

               
                

            }

            // buttons.push(GeniuzPOS.Common.Helpers.IcReportStockcardPdfHelper.createToolButton({
            //     grid: this,
            //     onViewSubmit: () => this.onViewSubmit(),
            //     reportTitle: reportTitle,
            //     separator: true,
            //     // onCreateFilterDescriptions: (grid: Serenity.DataGrid<any, any>, gridColumns: Slick.Column[], options: GeniuzPOS.Common.Helpers.IcReportPdfOptions) => this.getFilterDescriptions(grid, gridColumns, options),

            //     pageNumbers: true,
            //     columnStyles: columnStyles,
            //     // groupHeader: {
            //     //     0: { title: 'หน่วย', startX: 125, width: 70 }
            //     // },
            //     hideGroupColumn: false,
            //     // pageSize:{width:210,height:297},
            //     theme: 'plain',
            //     showTableHead: 'everyPage',
            //     isCustomHeader: true,
            //     //reportTitle: "This is report title",
            //     titleTop: 7,
            //     titleFontSize: 12,
            //     fileName: "ThisIsTheFileName",
            //     //pageNumbers: true,
            //     columnTitles: {
            //         'OriginalColumn': 'OCol.',
            //     },
            //     tableOptions: {
            //         columnStyles: {
            //             OriginalColumn: {
            //                 // columnWidth: 25,
            //                 halign: 'right'
            //             }
            //         }
            //     }
            // }));

            // buttons.push(GeniuzPOS.Common.Helpers.IcReportStockcardPdfHelper.createToolButton({
            //     grid: this,
            //     onViewSubmit: () => this.onViewSubmit(),
            //     reportTitle: reportTitle,
            //     separator: true,
            //     // onCreateFilterDescriptions: (grid: Serenity.DataGrid<any, any>, gridColumns: Slick.Column[], options: GeniuzPOS.Common.Helpers.IcReportPdfOptions) => this.getFilterDescriptions(grid, gridColumns, options),

            //     pageNumbers: true,
            //     autoPrint: true,
            //     output: "dataurlnewwindow",
            //     columnStyles: columnStyles,
            //     // groupHeader: {
            //     //     0: { title: 'หน่วย', startX: 125, width: 70 }
            //     // },
            //     hideGroupColumn: false,
            //     theme: 'plain',

            //     showTableHead: 'everyPage',
            //     isCustomHeader: true,

            //     //reportTitle: "This is report title",
            //     titleTop: 7,
            //     titleFontSize: 12,
            //     fileName: "ThisIsTheFileName",
            //     //pageNumbers: true,
            //     columnTitles: {
            //         'OriginalColumn': 'OCol.',
            //     },
            //     tableOptions: {
            //         columnStyles: {
            //             OriginalColumn: {
            //                 // columnWidth: 25,
            //                 halign: 'right'
            //             }
            //         }
            //     }
            // }));


            buttons.push(
                {
                    title: Q.text("Close"), // *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    onClick: () => {
                        window.location.href = '/QRreport/QRyStockcard#new';
                        return false;
                    },
                }
            );
            return buttons;
        }

        protected getSlickOptions() {
            var opt = super.getSlickOptions();
            opt.groupingPanel = true;

            // opt.showFooterRow = true;
            return opt;
        }

        // protected onViewSubmit() {
        //     if (!super.onViewSubmit()) {
        //         return false;
        //     }
    
        //     var request = this.view.params as Serenity.ListRequest;
    
        //     request.Criteria = Serenity.Criteria.and(request.Criteria,
        //         [['Username'], '=', Authorization.userDefinition.Username]);///ยังไม่รุ้ว่าทำไรได้
    
        //     return true;
        // }

    //     var request = this.view.params as DisplayTimeTableListRequest;
    //   request.Year = Number(this.targetYear.value);
    //   Q.serviceRequest('Time/DisplayTimeTable/List', request, (response) => { });

        //ทดลองหา ค่าบนวิวมาตัวนึง
        // protected onViewProcessData(response: Serenity.ListResponse<InventoryReport.IcReport07SkuRow>) {
        //     response = super.onViewProcessData(response);

        //     // there is no __id property in CustomerGrossSalesRow but 
        //     // this is javascript and we can set any property of an object
        //     // for (var x of response.Entities) {
        //     //     (x as any).__id = this.nextId++;
        //     // }
        //     let x = response.Entities.values
        //     console.log(x)

        //     return response;
        // }

    }
}